import { render, staticRenderFns } from "./FeeRecords.vue?vue&type=template&id=ae3eb8f2&"
import script from "./FeeRecords.vue?vue&type=script&lang=js&"
export * from "./FeeRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports